<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import "@/style/element.scss";
import "@/style/query.css";
import "@/style/skin.scss";
// import "@/style/zh-skin.scss";
export default {
  name: "App",
};
</script>

<style>
/* @import url('element-ui/lib/theme-chalk/index.css'); */
* {
  box-sizing: border-box;
}
html,
body {
  margin: 0 !important;
  padding: 0 !important;
  padding-right: 0 !important;
  background-color: #f8f8f8;
}

li {
  list-style: none;
}

ul {
  padding-left: 0;
}

a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue